import React, { useState, useEffect, useRef } from "react";
import SunEditor from "suneditor-react";

const Editor = ({ label, name, value, onChange }) => {
  const [contents, setcontents] = useState(value);
  const onChangeEvent = (content) => {
    // console.log(content);
    setcontents(content);
    onChange(name, content);
  };

  // create component did update
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  const prevContent = usePrevious(value);
  useEffect(() => {
    if (prevContent !== value) {
      setcontents(value);
    }
  }, [prevContent, value]);

  //   const onScrollEvent = (event) => {
  //     console.log(event);
  //   };
  //   const onClickEvent = (event) => {
  //     console.log(event);
  //   };
  //   const onMouseDownEvent = (event) => {
  //     console.log(event);
  //   };
  //   const onKeyUpEvent = (event) => {
  //     console.log(event);
  //   };
  //   const onFocusEvent = (event) => {
  //     console.log(event);
  //   };

  return (
    <SunEditor
      name={name}
      placeholder={label}
      defaultValue={contents}
      setContents={value}
      onChange={onChangeEvent}
      //   onScroll={onScrollEvent}
      //   onClick={onClickEvent}
      //   onMouseDown={onMouseDownEvent}
      //   onKeyUp={onKeyUpEvent}
      //   onFocus={onFocusEvent}
      setOptions={{
        buttonList: [
          ["undo", "redo"],
          ["font", "fontSize", "formatBlock"],
          ["paragraphStyle", "blockquote"],
          ["bold", "underline", "italic", "strike", "subscript", "superscript"],
          ["fontColor", "hiliteColor", "textStyle"],
          ["removeFormat"],
          ["outdent", "indent"],
          ["align", "horizontalRule", "list", "lineHeight"],
          ["table", "link", "image", "video", "audio"],
          ["imageGallery"],
          ["fullScreen", "showBlocks", "codeView"],
          ["preview", "print"],
          ["save", "template"],
        ],
      }}
    />
  );
};

export default Editor;
